import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePavilion } from '../contexts/PavilionContext';

export const Download = () => {
  const navigate = useNavigate();
  const { affiliate } = useParams();
  const { isPavilionMode } = usePavilion();

  useEffect(() => {
    // Redirect to Pavilion domain with affiliate context using the /a/ route structure
    window.location.href = `https://pavilion.playcast.io/a/${affiliate}`;
  }, [affiliate]);

  return null;
};
